import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page12() {
  useEffect(() => {
    document.title = "Маяк — Страница 11"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page10" />
        <ForwardLink href="/page12" />
      </div>

      <p style={{ textAlign: "right" }}>11.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        За тебя, моя красота!
      </p>
      <br/>
      <p>СНАРУЖИ. ЗДАНИЕ ФОГОРНА – НОЧЬ</p>
      <p>МУЗЫКА ПРОДОЛЖАЕТ ИГРАТЬ.</p>
      <p>
        МОЛОДОЙ смотрит на волшебный свет. Восемь лучей --<br/>
        вращающийся эффект «starburst». Странные световые узоры танцуют<br/>
        на скалах внизу. Это действительно впечатляюще. Он жаждет этого.<br/>
        Инстиктивно.
      </p>
      <p>
        Он рядом с сигнальным постом. Это странно выглядещее здание<br/>
        с огромной торчащей трубой, поддерживаемой шаткими подпорками.
      </p>
      <p>
        МОЛОДОЙ пытается зажечь сигарету. Ветер и сырость<br/>
        туманного воздуха делает это невозможным.
      </p>
      <p>Спичка не зажигается.</p>
      <p>ФОГОРН РЕВЕТ.</p>
      <p>
        МОЛОДОЙ снова чиркает спичкой. Спичка загорается... ветер<br/>
        сдувает ее. <i>Проклятие!</i>
      </p>
      <p>Он снова зажигает спичку...</p>
      <p>ФОГОРН РЕВЕТ.</p>
      <br/>
      <p>ВНУТРИ/СНАРУЖИ. ЛОДОЧНЫЙ САРАЙ/БЕРЕГ – ЧУТЬ ПОЗЖЕ</p>
      <p>МУЗЫКА ПРОДОЛЖАЕТ ИГРАТЬ.</p>
      <p>
        МОЛОДОЙ наконец курит сигарету. Медленно идет<br/>
        к берегу...
      </p>
      <p>
        ЕГО ТЯНЕТ К СВЕТУ от маяка, отражающемуся<br/>
        в воде.
      </p>
      <p>Он останавливается, волны плещутся о скалы.</p>
      <p>Он начинает заходить в море...</p>
      <p>
        Он идет дальше, не останавливается... ЗАГИПНОТИЗИРОВАННЫЙ<br/>
        водой...
      </p>
      <p><u>СВЕТ</u>...</p>
      <p><u>ЭТО ШАР СВЕТА</u> В МОРЕ...?</p>
      <p>Дальше...</p>
      <p style={{ textAlign: "right" }}>11.</p>
      
      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page10" />
        <ForwardLink href="/page12" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1708109177/the-lighthouse-script/enwpkj8z1perjg1grgau.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page12;
